module.exports = __webpack_public_path__ + "static/media/paiement_sécurisé_par_stripe.8e6e344b.png";